enum ScreenOptionsEnum {
    ORDERS = "orders",
    INVENTORY = "inventory",
    QUOTES = "quotes",
    TEMPLATES = "templates",
    SHIPPING = "shipping",
    PICK_LISTS = "pick_lists",
    PACKING_LISTS = "packing_lists",
    WAREHOUSES = "warehouses",
    ACCOUNTS = "accounts",
    ACCOUNT_USERS = "account_users",
    USERS = "users",
    PURCHASE_ORDERS = "purchase_orders",
    CATALOGS = "catalogs",
    ORDER_ENTRY = "order_entry",
    DAILY_ROUTES = "daily_routes",
    REPORTS = "reports",
    INVENTORY_LOG = "inventory_log",
}

export default ScreenOptionsEnum;
